<template>
  <div class="offLineApplyForm w1200">
    <div class="title">
      <span>1.填写信息</span>
      <i class="iconfont icon-zwjinru nextStep"></i>
      <span class="secondStep">2.提交订单</span>
    </div>
    <!-- 购票信息 -->
    <div class="ticketInfo">
      <h3>购票信息</h3>
      <div class="tickerItem">
        <span class="label">会议名称</span>
        <span class="content">{{ ticketInfo.title }}</span>
      </div>
      <div class="tickerItem">
        <span class="label">会议时间</span>
        <span class="content">{{ ticketInfo.time }}</span>
      </div>
      <div class="tickerItem">
        <span class="label">会议地点</span>
        <span class="content">{{ ticketInfo.side }}</span>
      </div>
      <div class="tickerItem">
        <span class="label">会议票种</span>
        <span class="content">{{ ticketInfo.ticket_title }}</span>
      </div>
      <div class="tickerItem">
        <span class="label">购票价格</span>
        <span class="content red">￥{{ ticketInfo.price }}</span>
      </div>
      <div class="tickerItem">
        <span class="red">注：</span>
        门票一经售出不予退还，请谨慎购买。
      </div>
    </div>
    <!-- 参会人 -->
    <div class="participator">
      <div class="titleBox">
        <h3>参会人信息</h3>
        <span>已选参会人{{ checkboxValue.length }}/{{ ticketInfo.num }} </span>
      </div>
      <a-button type="primary" size="large" block @click="addPeople"><i
          class="iconfont icon-zwxinzeng"></i>新增参会人</a-button>
      <ul class="peopleList">
        <a-checkbox-group v-model:value="checkboxValue" @change="checkboxChange" style="width: 100%">
          <li :class="checkboxValue.indexOf(item.id) > -1 ? 'selected' : ''" v-for="item in peopleInfo" :key="item.id">
            <img src="@/assets/images/select_icon.png" class="selecIcon"
              v-show="checkboxValue.indexOf(item.id) > -1 == true" />
            <div class="name">{{ item.name }}</div>
            <div class="phone">{{ item.phone }}</div>
            <div class="email">{{ item.email }}</div>
            <div class="operate">
              <i class="iconfont icon-zwxiugai" @click.stop="editInfo(item)"></i>
              <a-popconfirm title="确定删除该人员吗？" ok-text="确定" cancel-text="取消" @confirm.stop="deleteInfo(item.id)"
                @cancel="deleteCancel">
                <i class="iconfont icon-zwshan"></i>
              </a-popconfirm>
            </div>
            <a-checkbox :value="item.id"></a-checkbox>
          </li>
        </a-checkbox-group>
      </ul>
    </div>
    <!-- 其他信息 -->
    <div class="otherInfo">
      <h3>其他信息</h3>
      <a-form ref="applyFormRef" :label-col="{ span: 24 }" :model="applyForm" layout="vertical" :rules="applyFormRules">
        <template v-if="ticketInfo.form != 1">
          <a-form-item name="company" label="公司名称：">
            <a-input v-model:value="applyForm.company" placeholder="请填写公司名称" allow-clear />
          </a-form-item>
          <a-form-item name="type" label="行业类型：" required>
            <a-select v-model:value="applyForm.type" style="width: 100%">
              <a-select-option value="1">电商</a-select-option>
              <a-select-option value="2">游戏</a-select-option>
              <a-select-option value="3">APP</a-select-option>
              <a-select-option value="4">服务商</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item name="cooperation" label="是否合作" required>
            <a-select v-model:value="applyForm.cooperation">
              <a-select-option value="1">是</a-select-option>
              <a-select-option value="2">否</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="备注信息">
            <a-textarea v-model:value="applyForm.remark" :rows="4" />
          </a-form-item>
        </template>
        <template v-if="surveyForm.type == 1">
          <!-- :name="'[' + index + '].value'" -->
          <template v-for="(item, index) in surveyForm.forms" :key="index">
            <a-form-item :rules="[
              { required: item.is_required == 1 ? true : false, message: '请选择' + item.problem, trigger: 'change' },
            ]">
              <template #label>
                <div class="labelName">
                  <span>{{ item.problem }}</span>
                  <span style="color: #ff4d4f" v-if="item.is_required == 1">(必填)</span>
                </div>
              </template>
              <a-input v-model:value="item.value" :placeholder="item.problem" allow-clear v-if="item.type == 0" />
              <a-radio-group v-model:value="item.value" :options="item.answer" v-if="item.type == 1" />
              <a-checkbox-group v-model:value="item.value" :options="item.answer" v-if="item.type == 2" />
              <a-select ref="select" v-model:value="item.value" :options="item.answer" v-if="item.type == 3" />
              <a-textarea v-model:value="item.value" :rows="4" v-if="item.type == 4" />
            </a-form-item>
          </template>
        </template>
      </a-form>
      <div class="formSubmit">
        <span class="totalPrice">
          总价：<i>￥{{ priceTotal }}</i>
        </span>
        <a-button type="primary" size="large" @click="applyFinish" v-if="priceTotal == 0">确认提交</a-button>
        <a-button type="primary" size="large" @click="applyFinish1" v-else>确认提交</a-button>
      </div>
    </div>
  </div>

  <!-- 新增参会人 -->
  <a-modal v-model:visible="applyVisible" class="applyDialog" width="600px" @cancel="handleCancel" @ok="handleOk">
    <h3>{{ formTitle }}</h3>
    <p><img src="@/assets/images/WarningIcon.png" alt="" /> 参会人手机号将用于参会签到，请确保填写正确</p>
    <a-form ref="addFormRef" :label-col="{ span: 3 }" :model="addForm" :rules="addFormRules">
      <a-form-item name="name" label="姓名：">
        <a-input v-model:value="addForm.name" placeholder="请填写真实姓名" allow-clear />
      </a-form-item>
      <a-form-item name="phone" label="手机：">
        <a-input v-model:value="addForm.phone" placeholder="请填写手机号" allow-clear />
      </a-form-item>
      <a-form-item name="email" label="邮箱：">
        <a-input v-model:value="addForm.email" placeholder="请填写邮箱" allow-clear />
      </a-form-item>
    </a-form>
    <template #footer>
      <div class="footerBtn">
        <a-button size="large" type="primary" @click="addSubmitBtn">提交</a-button>
        <a-button size="large" @click="handleCancel">取消</a-button>
      </div>
    </template>
  </a-modal>

  <a-modal wrapClassName="codeModal" v-model:visible="codeVisible" title="" width="430px" :centered="true"
    @cancel="codeModalCancel">
    <template #footer></template>
    <div class="codeBg">
      <img class="server_qrcode" :src="live_code" alt="" />
    </div>
  </a-modal>
</template>

<script>
import { handleEventTracking } from '@/request/api/common'

export default {
  name: 'OffLineApply',
  props: ['ticketId'],
  data() {
    let checkMobile = async (rule, value) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[0-9]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      if (value === '') {
        return Promise.reject('请输入您的手机号')
      } else if (!regMobile.test(value)) {
        return Promise.reject('请输入有效的电话号码')
      } else {
        return Promise.resolve()
      }
    }
    return {
      userInfo: null,
      ticketReturnID: 0,
      ticketInfo: {},
      peopleInfo: [],
      selected: false,
      selectedId: 0,
      checkboxValue: [],
      applyForm: {
        company: '',
        type: '',
        cooperation: '',
        remark: '',
      },
      applyFormRules: {
        company: [{ required: true, message: '请填写公司名称', trigger: 'blur' }],
      },
      applyVisible: false,
      formTitle: '新增参会人',
      addFormType: 0,
      addForm: {
        id: '',
        name: '',
        phone: '',
        email: '',
      },
      editForm: {},
      addFormRules: {
        name: [{ required: true, message: '请填写真实姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请填写邮箱', trigger: 'blur' },
          {
            pattern: /(^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$)/,
            message: '请输入正确格式的邮箱号码',
            trigger: 'change',
          },
        ],
      },
      priceTotal: 0,
      surveyForm: [],
      live_code: '',
      codeVisible: false,
      is_added: true,
    }
  },
  mounted() {
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    if (this.userInfo == null) {
      this.$router.push({
        name: 'OffLineDetails',
        query: {
          id: this.ticketReturnID,
        },
      })
    }
    this.getTicketData()
    this.getPeopleInfo()
  },
  methods: {
    async getTicketData() {
      console.log(this.ticketId)
      const { data: res } = await this.$http.post('/offline/buy_offline', {
        _id: this.ticketId,
      })
      if (res.code == 100) {
        this.$message.warning(`${res.msg}`)
        this.$router.push({
          name: 'OffLineDetails',
          query: {
            id: res.id,
          },
        })
      }
      if (res.code == 300) {
        window.localStorage.clear()
        this.$router.push('/index')
      }
      console.log(res)
      this.surveyForm = res.form
      this.ticketInfo = res.data
      this.ticketReturnID = res.id
    },
    async getPeopleInfo() {
      const { data: res } = await this.$http.post('/offline/get_user')
      this.peopleInfo = res.data
    },
    async addPeople() {
      this.addForm.id = ''
      this.applyVisible = true
    },
    editInfo(info) {
      this.formTitle = '编辑参会人'
      this.applyVisible = true
      this.addFormType = 1
      this.addForm = info
    },
    async deleteInfo(id) {
      const { data: res } = await this.$http.post('/offline/del_user', {
        id: id,
      })
      if (res.code == 100) {
        return this.$message.warning(`${res.msg}`)
      }
      if (res.code == 300) {
        this.$message.warning('登录已失效')
        window.localStorage.clear()
        this.$router.push('/index')
      }
      if (res.code == 200) {
        this.$message.success(`${res.msg}`)
        this.getPeopleInfo()
      }
    },
    deleteCancel() {
      this.$message.info('取消删除')
    },
    checkboxChange(value) {
      if (value.length > this.ticketInfo.num) {
        this.checkboxValue.splice(this.ticketInfo.num)
        return this.$message.warning('选择人数受限')
      }
      console.log(this.ticketInfo.price, value.length)
      this.priceTotal = this.ticketInfo.price * value.length
    },
    handleCancel() {
      this.$refs.addFormRef.resetFields()
      this.applyVisible = false
      this.addFormType = 0
      this.formTitle = '新增参会人'
      this.getPeopleInfo()
    },
    handleOk() { },
    async addSubmitBtn() {
      if (this.priceTotal > 0) {
      }
      try {
        const values = await this.$refs.addFormRef.validateFields()
        const { data: res } = await this.$http.post('/offline/add_user', {
          type: this.addFormType,
          id: this.addForm.id,
          name: this.addForm.name,
          phone: this.addForm.phone,
          email: this.addForm.email,
        })
        if (res.code == 100) {
          return this.$message.warning(`${res.msg}`)
        }
        if (res.code == 300) {
          this.$message.warning('登录已失效')
          window.localStorage.clear()
          this.$router.push('/index')
        }
        if (res.code == 200) {
          this.getPeopleInfo()
          if (this.addFormType == 0) {
            this.$message.success('添加成功')
          } else {
            this.$message.success('编辑成功')
          }

          this.$refs.addFormRef.resetFields()
          this.applyVisible = false
        }
      } catch (errorInfo) {
        // console.log('Failed:', errorInfo.outOfDate)
      }
    },
    // 免费报名
    async applyFinish() {
      if (this.ticketInfo.form == 1) {
        if (this.checkboxValue.length == 0) {
          return this.$message.warning('请选择参会人')
        }

        const { data: res } = await this.$http.post('/offline/add_order_offline', {
          _id: this.ticketId,
          user: this.checkboxValue,
          type: this.ticketInfo.form,
          company: this.applyForm.company,
          business_type: this.applyForm.type,
          is_website: this.applyForm.cooperation,
          note: this.applyForm.remark,
          source: window.localStorage.getItem('source'),
          surveyForm: this.surveyForm,
        })
        if (res.code == 100) {
          return this.$message.warning(`${res.msg}`)
        }
        if (res.code == 300) {
          this.$message.warning('登录已失效')
          window.localStorage.clear()
          this.$router.push('/index')
        }
        if (res.code == 200) {
          this.$router.push({
            name: 'ApplyResult',
            query: {
              id: res.id,
            },
          })
          this.$refs.applyFormRef.resetFields()
        }
      } else {
        if (this.checkboxValue.length == 0) {
          return this.$message.warning('请选择参会人')
        }
        try {
          const values = await this.$refs.applyFormRef.validateFields()
          const { data: res } = await this.$http.post('/offline/add_order_offline', {
            _id: this.ticketId,
            user: this.checkboxValue,
            type: this.ticketInfo.form,
            company: this.applyForm.company,
            business_type: this.applyForm.type,
            is_website: this.applyForm.cooperation,
            note: this.applyForm.remark,
            source: window.localStorage.getItem('source'),
            surveyForm: this.surveyForm,
          })
          if (res.code == 100) {
            return this.$message.warning(`${res.msg}`)
          }
          if (res.code == 300) {
            this.$message.warning('登录已失效')
            window.localStorage.clear()
            this.$router.push('/index')
          }
          if (res.code == 200) {
            this.pushId = res.id
            wlRegisterComp.linkToWL(
              {
                wl_qrcode_id: '1597886613810147328', // 需要使用的智能码ID
                client_user_id: this.userInfo.phone, // 用户在贵公司平台的唯一
                sign_mode: false, // 可选参数 不传时默认false 是否校验签名
                sign: '', //string 可选参数 sign_mode为true时传输 加密后的签名
                current_time: 0, //可选参数 sign_mode为true时传输 加密签名时使用的毫秒时间戳
                formData: {
                  联系人: this.checkboxValue[0],
                  手机号: this.userInfo.phone,
                  公司名称: this.applyForm.company,
                  邮箱: this.userInfo.email == null ? '' : this.userInfo.email,
                }, // 用户填写的注册或登录信息，value可以为空，但key值必填
                is_update: true, // 此次提交是否为数据更新，默认false
              },
              (data) => {
                // live_code
                handleEventTracking({ type: 4, phone: this.userInfo.phone, value: JSON.stringify(data) })
                if (data.msg == '当前用户已加好友') {
                  this.$router.push({
                    name: 'ApplyResult',
                    query: {
                      id: res.id,
                    },
                  })
                  this.$refs.applyFormRef.resetFields()
                } else {
                  this.live_code = data.data.live_code

                  wlRegisterComp.checkUserState(
                    this.userInfo.phone, // 用户在客户平台的唯一ID
                    (data) => {
                      // is_added == false 弹出
                      this.is_added = data.data.is_added
                      if (data.data.is_added == false) {
                        this.codeVisible = true
                      }

                      if (this.is_added == true) {
                        this.$router.push({
                          name: 'ApplyResult',
                          query: {
                            id: res.id,
                          },
                        })
                        this.$refs.applyFormRef.resetFields()
                      }
                    }
                  )
                }
              }
            )
          }
        } catch (errorInfo) {
          // console.log('Failed:', errorInfo.outOfDate)
        }
      }
    },
    codeModalCancel() {
      this.$router.push({
        name: 'ApplyResult',
        query: {
          id: this.pushId,
        },
      })
      this.$refs.applyFormRef.resetFields()
    },
    // 收费报名
    async applyFinish1() {
      if (this.ticketInfo.form == 1) {
        if (this.checkboxValue.length == 0) {
          return this.$message.warning('请选择参会人')
        }

        const { data: res } = await this.$http.post('/offline/add_buy_offline', {
          _id: this.ticketId,
          user: this.checkboxValue,
          type: this.ticketInfo.form,
          company: this.applyForm.company,
          business_type: this.applyForm.type,
          is_website: this.applyForm.cooperation,
          note: this.applyForm.remark,
          source: window.localStorage.getItem('source'),
          surveyForm: this.surveyForm,
        })
        if (res.code == 100) {
          return this.$message.warning(`${res.msg}`)
        }
        if (res.code == 300) {
          this.$message.warning('登录已失效')
          window.localStorage.clear()
          this.$router.push('/index')
        }
        if (res.code == 200) {
          this.$router.push({
            name: 'PayPage',
            query: {
              id: res.order_id,
            },
          })
          this.$refs.applyFormRef.resetFields()
        }
      } else {
        if (this.checkboxValue.length == 0) {
          return this.$message.warning('请选择参会人')
        }
        try {
          const values = await this.$refs.applyFormRef.validateFields()
          const { data: res } = await this.$http.post('/offline/add_buy_offline', {
            _id: this.ticketId,
            user: this.checkboxValue,
            type: this.ticketInfo.form,
            company: this.applyForm.company,
            business_type: this.applyForm.type,
            is_website: this.applyForm.cooperation,
            note: this.applyForm.remark,
            source: window.localStorage.getItem('source'),
            surveyForm: this.surveyForm,
          })
          if (res.code == 100) {
            return this.$message.warning(`${res.msg}`)
          }
          if (res.code == 300) {
            this.$message.warning('登录已失效')
            window.localStorage.clear()
            this.$router.push('/index')
          }
          if (res.code == 200) {
            this.pushId = res.id
            var email = this.userInfo.email == null ? '' : this.userInfo.email
            wlRegisterComp.linkToWL(
              {
                wl_qrcode_id: '1597886613810147328', // 需要使用的智能码ID
                client_user_id: this.userInfo.phone, // 用户在贵公司平台的唯一
                sign_mode: false, // 可选参数 不传时默认false 是否校验签名
                sign: '', //string 可选参数 sign_mode为true时传输 加密后的签名
                current_time: 0, //可选参数 sign_mode为true时传输 加密签名时使用的毫秒时间戳
                formData: {
                  联系人: this.checkboxValue[0],
                  手机号: this.userInfo.phone,
                  公司名称: this.applyForm.company,
                  邮箱: email,
                }, // 用户填写的注册或登录信息，value可以为空，但key值必填
                is_update: true, // 此次提交是否为数据更新，默认false
              },
              (data) => {
                // live_code
                handleEventTracking({ type: 4, phone: this.userInfo.phone, value: JSON.stringify(data) })
                if (data.msg == '当前用户已加好友') {
                  this.$router.push({
                    name: 'PayPage',
                    query: {
                      id: res.order_id,
                    },
                  })
                  this.$refs.applyFormRef.resetFields()
                } else {
                  this.live_code = data.data.live_code

                  wlRegisterComp.checkUserState(
                    this.userInfo.phone, // 用户在客户平台的唯一ID
                    (data) => {
                      // is_added == false 弹出
                      this.is_added = data.data.is_added
                      if (data.data.is_added == false) {
                        this.codeVisible = true
                      }

                      if (this.is_added == true) {
                        this.$router.push({
                          name: 'PayPage',
                          query: {
                            id: res.order_id,
                          },
                        })
                        this.$refs.applyFormRef.resetFields()
                      }
                    }
                  )
                }
              }
            )
          }
        } catch (errorInfo) {
          // console.log('Failed:', errorInfo.outOfDate)
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.offLineApplyForm {
  background-color: #fff;
  padding: 40px 0;

  .title {
    height: 44px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    padding-left: 40px;
    margin-bottom: 40px;

    span {
      border-bottom: 2px solid #3A84FF;
      padding-bottom: 14px;
    }

    span.secondStep {
      border-bottom: none;
      color: rgba(0, 0, 0, 0.45);
    }

    i.nextStep {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      margin: 0 48px;
    }
  }

  .ticketInfo {
    width: 860px;
    height: 315px;
    background-color: #f1f1f1;
    margin: 40px auto;
    padding: 32px;
    border-radius: 4px;

    h3 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 16px;
    }

    .tickerItem {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.45);
      margin-bottom: 16px;

      .label {
        margin-right: 8px;
      }

      .content {
        color: rgba(0, 0, 0, 0.85);
      }

      .red {
        color: #ff4d4f !important;
      }
    }
  }

  .participator {
    width: 860px;
    height: auto;
    border: 1px solid rgba(0, 0, 0, 0.15);
    margin: 0 auto 40px;
    padding: 32px;
    border-radius: 4px;

    .titleBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 32px;

      h3 {
        font-size: 16px;
        font-weight: bold;
      }

      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .ant-btn {
      border-radius: 74px;

      i {
        margin-right: 8px;
      }
    }

    .peopleList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      :deep(.ant-checkbox-group) {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        &::after {
          content: '';
          width: 232px;
        }
      }

      li {
        position: relative;
        width: 232px;
        height: 146px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        padding: 16px;
        margin-top: 18px;
        cursor: pointer;

        :deep(.ant-checkbox) {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0px;
          left: 0px;

          .ant-checkbox-inner {
            width: 0;
            height: 0;
            border: 0;
            border-radius: 0;
          }
        }

        .selecIcon {
          position: absolute;
          bottom: 0;
          right: 0;
        }

        >div {
          font-size: 14px;
          color: #000;
          margin-bottom: 16px;
        }

        .operate {
          position: absolute;
          top: 16px;
          right: 16px;
          z-index: 2;

          i {
            font-size: 18px;
            color: #000;
            cursor: pointer;
          }

          i.icon-zwxiugai {
            margin-right: 16px;
          }
        }
      }

      .selected {
        border: 1px solid #3A84FF;
      }

      &::after {
        content: '';
        width: 232px;
      }
    }
  }

  .otherInfo {
    width: 860px;
    height: auto;
    border: 1px solid rgba(0, 0, 0, 0.15);
    margin: 0 auto;
    padding: 32px;
    border-radius: 4px;

    h3 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 16px;
    }

    .formSubmit {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 60px;

      .totalPrice {
        color: rgba(0, 0, 0, 0.85);

        i {
          font-size: 30px;
          font-weight: bold;
          color: #ff4d4f;
        }
      }

      .ant-btn {
        width: 180px;
        border-radius: 53px;
      }
    }

    .labelName {
      display: flex;
      align-items: center;
      width: 100%;
    }
  }
}

.applyDialog {
  h3 {
    font-size: 28px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
  }

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ffbb52;
    margin: 32px 0;

    img {
      width: 20px;
      height: 20px;
      margin-right: 2px;
    }
  }

  .footerBtn {
    display: flex;
    justify-content: center;
    padding-bottom: 16px;

    .ant-btn {
      width: 180px;
      border-radius: 53px;
      margin: 0 20px;
    }
  }
}

.codeBg {
  position: relative;
  width: 430px;
  height: 560px;
  background: url('@/assets/images/popBG.png') no-repeat;
  background-size: 100%;
  margin: 0 auto;
}

.server_qrcode {
  width: 268px;
  height: 268px;
  position: absolute;
  top: 211px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
